export default __webpack_public_path__ + "static/media/archer.b31ae021.svg";